"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ImagePickerTypeEnum_1 = require("../enums/ImagePickerTypeEnum");
var ATLAtomButton_1 = require("../atoms/ATLAtomButton");
var getProportionFromToken_1 = require("../utils/getProportionFromToken");
var ATLAtomImage_1 = require("../atoms/ATLAtomImage");
var ImageResizeModeEnum_1 = require("../enums/ImageResizeModeEnum");
var defaultProps = {
    type: ImagePickerTypeEnum_1.ImagePickerTypeEnum.square,
    hasMargin: false
};
var SCREEN_WIDTH = react_native_1.Dimensions.get('window').width;
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.ImagePickerWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding:  ", "px\n            ", "px;\n"], ["\n\tpadding:  ", "px\n            ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingMarginal;
});
exports.ImagePickerWrapperNoMargin = native_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tpadding:  0 0 ", "px 0;\n"], ["\n\tpadding:  0 0 ", "px 0;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
});
exports.ButtonWrapper = native_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 8px 16px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: ", "px;\n\tpadding:  0 0 ", "px 0;\n"], ["\n  margin: 8px 16px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: ", "px;\n\tpadding:  0 0 ", "px 0;\n"])), function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.WidthImagePickerButton;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
});
exports.EditorPlaceholder = native_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", "px;\n\theight: ", "px;\n\tbackground-color: ", ";\n"], ["\n  width: ",
    "px;\n\theight: ", "px;\n\tbackground-color: ", ";\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.hasMargin ?
        (SCREEN_WIDTH - 2 * (props.horizontalMargin || atlTheme.SpacingMarginal)) : (SCREEN_WIDTH);
}, function (props) { return SCREEN_WIDTH * props.proportion; }, function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.ColorLowContrast;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLImagePicker = function (_a) {
    var buttonText = _a.buttonText, placeholderImage = _a.placeholderImage, source = _a.source, type = _a.type, hasMargin = _a.hasMargin, isButtonDisabled = _a.isButtonDisabled, onPressButton = _a.onPressButton, horizontalMargin = _a.horizontalMargin, verticalMargin = _a.verticalMargin, buttonBaseProps = _a.buttonBaseProps, imageBaseProps = _a.imageBaseProps;
    var theme = ThemeProvider_1.useTheme();
    var _b = react_1.useState(1), proportion = _b[0], setProportion = _b[1];
    react_1.useEffect(function () {
        switch (type) {
            case ImagePickerTypeEnum_1.ImagePickerTypeEnum.widest:
                setProportion(getProportionFromToken_1.getProportionFromToken(theme.ProportionWidest));
                break;
            case ImagePickerTypeEnum_1.ImagePickerTypeEnum.wide:
                setProportion(getProportionFromToken_1.getProportionFromToken(theme.ProportionWide));
                break;
            case ImagePickerTypeEnum_1.ImagePickerTypeEnum.square:
                setProportion(getProportionFromToken_1.getProportionFromToken(theme.ProportionSquare));
                break;
        }
    }, [type]);
    var renderButton = function () { return (react_1.default.createElement(exports.ButtonWrapper, { verticalMargin: verticalMargin },
        react_1.default.createElement(ATLAtomButton_1.ATLAtomButton, __assign({ title: buttonText, onPress: onPressButton, disabled: isButtonDisabled, borderColor: theme.ColorComplementary1, borderRadius: theme.BorderRadiusButton, borderWidth: theme.BorderWidthButton, buttonColor: theme.ColorComplementary1, buttonHeight: theme.HeightButtonBase, fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeButton, fontWeight: theme.FontWeightStrong, textCase: theme.TextCaseButton, textColorRegular: theme.ColorBrand1Default, disabledOpacity: theme.OpacityDisabled }, buttonBaseProps)))); };
    var renderImage = function () { return (react_1.default.createElement(ATLAtomImage_1.ATLAtomImage, __assign({ source: source, placeholder: placeholderImage, borderColor: theme.ColorNone, borderRadius: 0, borderWidth: 0, resizeMode: ImageResizeModeEnum_1.ImageResizeModeEnum.contain, height: SCREEN_WIDTH * proportion }, imageBaseProps))); };
    var renderComponentWithoutWrapper = function () { return (react_1.default.createElement(exports.EditorPlaceholder, { hasMargin: hasMargin, proportion: proportion, source: source, horizontalMargin: horizontalMargin },
        renderImage(),
        renderButton())); };
    // Returns complete ATLImagePicker
    return (hasMargin ? (react_1.default.createElement(exports.ImagePickerWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin }, renderComponentWithoutWrapper())) : (react_1.default.createElement(exports.ImagePickerWrapperNoMargin, { verticalMargin: verticalMargin }, renderComponentWithoutWrapper())));
};
exports.ATLImagePicker.defaultProps = defaultProps;
exports.ATLImagePicker.displayName = 'ATLImagePicker';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
